import BN from 'bn.js';
import { AppError } from 'src/redux/types';
export const getTotalPrices = (numberSelected, thgPerHero) => {
  return {
    token: thgPerHero.token,
    value: new BN(thgPerHero.value).mul(new BN(numberSelected)).toString()
  };
};
export const checkInvalidPrice = (totalPrice, balance) => {
  const priceBN = new BN(totalPrice.value);
  const balanceBN = new BN(balance.value);
  return priceBN.gt(balanceBN);
};
export const checkErrorInvalidPrice = (totalPrice, balance, stakeable) => {
  const priceBN = new BN(totalPrice.value);
  const balanceBN = new BN(balance.value);
  const stakeableBN = new BN(stakeable.value);
  if (priceBN.gt(balanceBN)) return AppError.INSUFFICIENT_BALANCE;else if (priceBN.gt(stakeableBN)) return AppError.STAKING_POOL_FULLED;
  return AppError.NO_ERROR;
};